import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { WindowMessagesService } from '@app/services/window-messages.service';

@Component({
  standalone: false,
  selector: 'app-ag-advise-banner',
  templateUrl: './ag-advise-banner.component.html',
  styleUrls: ['./ag-advise-banner.component.scss'],
})
export class AgAdviseBannerComponent {
  public endSession = false;
  constructor(
    private _router: Router,
    private readonly _windowMessagesService: WindowMessagesService
  ) {}

  continue(): void {
    this._router.navigate(['/loader']);
  }

  back(): void {
    sessionStorage.setItem('adviseBack',JSON.stringify(true));
    this._router.navigate(['/']);
  }

  /**
   * @description cancel
   */
  cancel(): void {
    this._windowMessagesService.cancel();
    this.endSession = true;
  }
}
